
// 国双统计
// export function gsqStat(action, category='onecloud_grabcode'){
// 	if(!window._gsq) window._gsq = []
// 	const platform = browser('pc') ? 'pc':'mobile'
// 	_gsq.push(["T", "GWD-005197", "trackEvent", category, action, platform]);
// }

// 百度统计
export function baiduStat(action, category='onecloud_grabcode'){
	if(!window._hmt) window._hmt = []
	_hmt.push(['_trackEvent', category, action]);
}

// google统计
// 20180111 更换为gta
// export function googleStat(action, category='onecloud_grabcode'){
// 	if(typeof gtag == 'function'){
// 		gtag('event', action,{
// 			'event_category':category,
// 			'event_action': action
// 		} );
// 	}
// }

// facebook统计
// export function facebookStat(action, category=''){
// 	if(typeof fbq != 'function') return;

// 	if(category == 'onecloud_purchase_hk'){
// 		if(action == 'login_success'){
// 			fbq('track', 'CompleteRegistration');
// 		}
// 		if(action == 'book_success'){
// 			fbq('track', 'Lead');
// 		}
// 	}
// }

/*export function selfReport(action, category="onecloud_grabcode"){
	const url = `http://zqb.red.xunlei.com/report?action=${action}&category=${category}&_=${Date.now()}`
	new Image().src = url
}
*/
// 统计
export function stat(action, category='onecloud_grabcode'){
	// category += `_${getLang()}`
	// // gsqStat(action, category)
	// baiduStat(action, category)
	// googleStat(action, category)
	// facebookStat(action, category)
}

// 浏览器判断
export function browser(type){
	var u = navigator.userAgent.toLowerCase();
	var versions = { //移动终端浏览器版本信息
		trident: u.indexOf('trident') > -1, //IE内核
		presto: u.indexOf('presto') > -1, //opera内核
		webKit: u.indexOf('appleWebKit') > -1, //苹果、谷歌内核
		gecko: u.indexOf('gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
		mobile: !!u.match(/appleWebKit.*mobile.*/), //是否为移动终端
		ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
		android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
		iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
		iPad: u.indexOf('ipad') > -1, //是否iPad
        iPod: u.indexOf('ipod') > -1,
		webApp: u.indexOf('safari') == -1, //是否web应该程序，没有头部与底部
		wx: u.indexOf('micromessenger') > -1,
		nokia: u.indexOf('nokia') > -1,
		pcwx : u.indexOf('windowswechat') > -1,
		pc: !/Android|iPhone|SymbianOS|Windows\s+Phone|iPad|iPod|XiaoMi\/MiuiBrowser/i.test(u),
		//ie: u.indexOf('msie') > -1,
		ie: (u.indexOf('msie') > -1 || u.indexOf('edge') > -1 || u.indexOf('trident')>-1) && u.indexOf('opera') == -1,
		x5: u.indexOf('mqqbrowser') > -1,
		weibo:u.indexOf('weibo') > -1 || u.indexOf('Weibo') > -1
	};
	return versions[type];
}

// 获取pc浏览器内核
export function getPcBrowser() {
    const ua = navigator.userAgent.toLowerCase()
    if ((!!window.opr && !!opr.addons) || !!window.opera || ua.indexOf(' opr/') >= 0) return 'opera'
    if (typeof InstallTrigger !== 'undefined') return 'firefox'
    if (/constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))) return 'safari'
    if (!!window.chrome && !!window.chrome.webstore && ua.indexOf('qqbrowser') !== -1) return 'qq-chrome'
    if (/*@cc_on!@*/false || !!document.documentMode && ua.indexOf('qqbrowser') !== -1) return 'qq-ie'
    if (/*@cc_on!@*/false || !!document.documentMode) return 'ie'
    if (!(/*@cc_on!@*/false || !!document.documentMode) && !!window.StyleMedia) return 'edge'
    if (!!window.chrome && !!window.chrome.webstore) return 'chrome'
    if ((!!window.chrome && !!window.chrome.webstore || ((!!window.opr && !!opr.addons) || !!window.opera || ua.indexOf(' opr/') >= 0)) && !!window.CSS) return 'blink'
    return ''
}

// 获取cookie
export function getCookie(name) {
	try {
		return (document.cookie.match(new RegExp("(^" + name + "| " + name + ")=([^;]*)")) == null) ? "" : decodeURIComponent(RegExp.$2);
	} catch (e) {
		return (document.cookie.match(new RegExp("(^" + name + "| " + name + ")=([^;]*)")) == null) ? "" : RegExp.$2;
	}
}

// 设置cookie
export function setCookie(name, value, expireMin, domain) {
	if (!domain) {
		domain = location.hostname.replace('wky', '');
	}
	if (arguments.length > 2) {
		var expireTime = new Date(new Date().getTime() + parseInt(expireMin * 60 * 1000));
		document.cookie = name + "=" + escape(value) + "; path=/; domain=" + domain + "; expires=" + expireTime.toGMTString();
	} else {
		document.cookie = name + "=" + escape(value) + "; path=/; domain=" + domain;
	}
}

// ajax post请求
export function ajaxPost(url, data, successCallback, errorCallback) {
	const _data = { csrf_token: getCookie('csrf_token'), ...data }
	$.ajax({
		type: 'POST',
		url: url,
		data: _data,
		crossDomain: true,
        xhrFields: { withCredentials: true },
        cache: false,
		ifModified: true,
		dataType: 'json',
		success: successCallback,
		error: errorCallback,
	})
}
export function postPromise(url, data, timeout) {
	const _data = { csrf_token: getCookie('csrf_token'), ...data }
	return $.ajax({
		type: 'POST',
		url: url,
		data: _data,
		crossDomain: true,
        xhrFields: { withCredentials: true },
        cache: false,
		ifModified: true,
		dataType: 'json',
		timeout: timeout||8000
	})
}

export function getPromise(url, data = {}, timeout) {
	return $.ajax({
	  type: 'GET',
	  url,
	  data,
	  crossDomain: true,
	  xhrFields: { withCredentials: true },
	  cache: false,
	  ifModified: true,
	  dataType: 'json',
	  timeout: timeout || 8000
	})
  }

export function getJSONP(url, jsonpCallback, successCallback){
	$.ajax({
		url: url,
		dataType: 'jsonp',
		jsonpCallback,
		success: successCallback
	})
}

// ajax get请求
export function ajaxGet(url, successCallback, errorCallback){
	$.ajax({
		url,
		crossDomain: true,
		cache:false,
		ifModified: true,
        xhrFields: { withCredentials: true },
		dataType: 'json',
		success: successCallback,
		error: errorCallback
	})
}

// 获取url参数
export function getParams (name) {
    const url = window.location.search,
    reg = new RegExp('[\\?&]' + name + '=([^&]*)'),
    v = url.match(reg);
    return v === null ? null : v[1];
}

// 个位数数字补 0
export function addZero(num) {
	return num >=0 && num < 10 ? '0' + num : num
}

// 获取剩余时间，倒计时用
export function surplusTime(currTime, targetTime, fillZero=true){
	const offset = Math.floor((targetTime.getTime() - currTime.getTime())/1000)
	const ts = offset > 0 ? offset : 0
	const dayStamp = 24*60*60
	const ret = {
		day: Math.floor(ts / dayStamp),
		hour: Math.floor((ts % dayStamp) / 3600),
		minute: Math.floor((ts % 3600)/60),
		second: ts % 60,
		offset
	}
	if(fillZero){
		ret.hour = addZero(ret.hour)
		ret.minute = addZero(ret.minute)
		ret.second = addZero(ret.second)
	}
	return ret
}

export function ScrollToElement(id, speed=50) {
	let element = document.getElementById(id)
    let rect = element.getBoundingClientRect();
    //获取元素相对窗口的top值，此处应加上窗口本身的偏移
    let top = window.pageYOffset + rect.top;
    let currentTop = 0;
    let requestId;
    //采用requestAnimationFrame，平滑动画
    function step(timestamp) {
      currentTop += speed;
      if (currentTop <= top) {
        window.scrollTo(0,currentTop);
        requestId=window.requestAnimationFrame(step);
      } else {
        window.cancelAnimationFrame(requestId);
      }
    }
    window.requestAnimationFrame(step);
  }

// 比较两个对象是否相等
export function isEquivalent(a, b) {
    const aProps = Object.getOwnPropertyNames(a);
    const bProps = Object.getOwnPropertyNames(b);
    if (aProps.length != bProps.length) {
        return false;
    }
	let propName;
    for (let i = 0, len = aProps.length; i < len; i++) {
        propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}

// 对象是否为空
export function isEmptyObject(o) {
    for (let i in o) {
        return false;
    }
    return true;
}

// 保留两位小数点
export function toFixedNum(num){
	return parseFloat(num.toFixed(2))
}

export function addClassToHtmlElement(){
	$('html').addClass('no-scroll')
}
export function removeClassFromHtmlElement(){
	$('html').removeClass('no-scroll')
}

// 禁止safari 浏览器后退时缓存页面，导致脚本不执行
export function disableSafariBackCache() {
    if ( navigator.userAgent.indexOf("Safari") > -1 ) {
        $(window).bind("pageshow", function (event) {
            if (event.originalEvent.persisted) {
                document.body.style.display = "none";
                window.location.reload();
            }
        });
    }
}

// 获取语言版本
export function getLang() {
	// return getCookie('lang') || 'cn';
	if(!window.LANG){
		let urlang = /^\/([a-zA-Z]{2})\/.*/.exec(location.pathname);
		window.LANG = urlang==null ? 'cn' : urlang[1];
		setCookie('lang', LANG, 24*60, location.host.replace('wky',''));
	}
	return window.LANG
}

export function getProtocol() {
	return location.protocol === 'https:' ? 'https://' : 'http://';
}

/**
 生成链接，会自动补全当前的语言
 createUrl('html/book') 生成: /html/book.html 或者 /hk/html/book.html
 createUrl('html/login', {a:1, b:2}) 生成: /html/book.html?a=1&b=2 或者 /hk/html/book.html?a=1&b=2
 */
export function createUrl(route, params=null) {
	const lang = getLang()
	if(route.substr(0,1) != '/'){
		route = lang !== 'cn' ? `/${lang}/${route}` : `/${route}`
	}
	route += '.html'
	if(params){
		let query = []
		for(let key in params){
			query.push(`${key}=${params[key]}`)
		}
		route += `?${query.join('&')}`
		// route += encodeURIComponent(`?${query.join('&')}`)
	}
	return route
}

// 以逗号分隔数字(返回示例：10,000,000)
export function formatNumberByComma(num) {
	return (num + "").replace(/(\d)(?=(\d{3})+$)/g,'$1,')
}

function hidePhoneMid4(phone = "") {
    return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
}

export {
	hidePhoneMid4
}


// WEBPACK FOOTER //
// ./js/src/common/utils.js